export default __webpack_public_path__ + "static/video-10e22c4fe0b4268a03598a3c4e766b96.png";